import { MenuOutlined } from '@ant-design/icons';
import { t } from '@framework/i18n';
import { Col, Row } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

export interface IMultiPreferenceRowWrapperProps {
  index?: number;
  readonly?: boolean;
  action?: React.ReactNode;
  children?: React.ReactNode;

  isLabelRow?: boolean;
}

const MultiPreferenceRowWrapperDiv = styled(Row)`
  // spazio tra le righe
  /* padding: 6px 0; */
  /* padding-top: 6px; */
  > .ant-col {
    min-width: 0;
  }

  // prima parte della riga con icona per il Drag
  // e numero elemento (indice)
  .drag-button {
    padding-left: 5px;
    padding-top: 8px;
    .anticon {
      font-size: 20px;
      padding-top: 2px;
    }
    &:hover {
      .anticon {
        color: ${props => props.theme.colorPrimary};
        cursor: grab;
      }
    }
  }
  .index-number {
    text-align: right;
    padding-right: 6px;
    padding-top: 8px;
    font-size: 16px;
    letter-spacing: -0.04em;
  }

  // pulsante per rimozione riga
  .action-button {
    text-align: right;
  }

  // Sezione delle select di input
  // per sovrapposizione elementi (visualizzazione unita)
  .input-wrapper > .ant-col {
    flex: 1 1 0;
    min-width: 0;
    + .ant-col {
      margin-left: -2px;
    }
  }

  .form-handler & .ant-form-item {
    padding-top: 0;
  }
`;

export function MultiPreferenceRowWrapper(
  props: Readonly<IMultiPreferenceRowWrapperProps>,
) {
  const { index, readonly, action, children, isLabelRow } = props;
  return (
    <MultiPreferenceRowWrapperDiv align="top">
      {!readonly && (
        <Col flex="0 0 25px">
          <div className="drag-button">
            <MenuOutlined
              aria-label={t(
                'multi-preference-widget.drag-to-sort',
                'Trascina per ordinare',
              )}
            />
          </div>
        </Col>
      )}
      {isLabelRow && readonly && (
        <Col flex="0 0 25px">
          <div className="drag-button"></div>
        </Col>
      )}
      <Col flex="0 0 28px" className="index-number">
        {renderIndex(index)}
      </Col>
      <Col flex="1 1 0">
        <Row className="input-wrapper" gutter={6}>
          {children}
        </Row>
      </Col>
      {!readonly && (
        <Col flex="0 0 120px" className="action-button">
          {action}
        </Col>
      )}
      {isLabelRow && readonly && (
        <Col flex="0 0 120px" className="action-button">
          <div />
        </Col>
      )}
    </MultiPreferenceRowWrapperDiv>
  );
}

function renderIndex(index: number | null | undefined) {
  if (index === null || index === undefined || index < 0) {
    // Se l'indice è nullo o negativo, non mostrare nulla
    return '';
  }

  return index + 1;
}
